"use strict";

exports.__esModule = true;
exports.default = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const merge = (obj1, obj2) => {
  let temp = _extends({}, obj1, obj2);

  Object.keys(temp).forEach(key => {
    if (typeof temp[key] === 'object' && !(temp[key] instanceof Array)) {
      temp[key] = _extends({}, obj1[key], obj2[key]);
    }
  });
  return temp;
};

var _default = merge;
exports.default = _default;
module.exports = exports.default;